export function legendPipe(verticalAlign: Highcharts.VerticalAlignValue, legend?: Highcharts.LegendOptions) {
  return (options: Highcharts.Options): Highcharts.Options => ({
    ...options,
    legend: {
      verticalAlign,
      ...legend
    },
  });
}